
export enum EquipmentIds {
	mat = "mat",

	chair = "chair",
	chairNoFallbacks = "chairNoFallbacks",
	balanceSupportWithFallbacks = "balanceSupportWithFallbacks",

	wall = "wall",
	wallNoFallbacks = "wall",
	wallWithFallbacks = "wall",
	fallbackBench = "wall",
	fallbackTable = "wall",

	dumbells = "dumbells",
	dumbbellsWithFallbacks = "dumbbellsWithFallbacks",
	fallbackCannedGoods = "fallbackCannedGoods",
	fallbackOneLitreDrinkBottle = "fallbackOneLitreDrinkBottle",

	foam = "balancePad",
	balancePad = "balancePad",
	balancePadWithFallbacks = "balancePad",
	fallbackFoldedTowel = "balancePad",
	fallbackChairCushion = "balancePad",

	grid = "grid",
	dartboard = "dartboard",

	footLeft = "footLeft",
	footRight = "footRight",
}